import { render } from "./VueFooter.vue?vue&type=template&id=2fc9fc07&scoped=true"
import script from "./VueFooter.vue?vue&type=script&lang=js"
export * from "./VueFooter.vue?vue&type=script&lang=js"

import "./VueFooter.vue?vue&type=style&index=0&id=2fc9fc07&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc9fc07"]])

export default __exports__